import axios from "axios";

/**
 * Fetch all road recordings data from the backend.
 * @param {string} baseUrl - The base URL for the API.
 * @returns {Promise<Array|String>} - Array of road recording objects or 'error' string.
 */
export async function getAllRoadRecordings(baseUrl) {
    try {
        const response = await axios.get(baseUrl + '/admin/getRoadRecordingsStorage', {
            timeout: 7000, // 7sec timeout
        });

        if (response.status === 200 && Array.isArray(response.data)) {
            return response.data;
        } else {
            console.error("Unexpected response format:", response.data);
            return 'error';
        }
    } catch (error) {
        if (error.code === 'ECONNABORTED') {
            console.error('Request timed out!');
        } else if (error.response) {
            console.error("Backend returned error status:", error.response.status, error.response.data);
        } else if (error.request) {
            console.error("No response received from backend:", error.request);
        } else {
            console.error("Error setting up the request:", error.message);
        }
        return 'error';
    }
}
